import { render, staticRenderFns } from "./card-edit.component.vue?vue&type=template&id=22b3a7c2"
import script from "./card-edit.component.vue?vue&type=script&lang=js"
export * from "./card-edit.component.vue?vue&type=script&lang=js"
import style0 from "./card-edit.component.vue?vue&type=style&index=0&id=22b3a7c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports